import {
    CreatePlatformProjectRequest,
    UpdateProjectPlatformRequest,
} from '@activepieces/ee-shared';
import {
    CreateAiBuilderReviewRequest,
} from '@activepieces/shared';

import { api } from '@/lib/api';
import { authenticationSession } from '@/lib/authentication-session';

export const AiBuilderReviewApi = {
    send: (request: CreateAiBuilderReviewRequest) => {
        return api.post<any>('/v1/ai-builder-review', request);
    },
};
